import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Trans } from 'react-i18next';
import { Section, Message, Date, TimeInput as Time } from '@weezevent/nacre';
import i18n from 'i18next';

function DateTime({ schedule, setSchedule }) {
    const today = schedule ? moment(schedule) : moment();
    const next = 5 - (today.minute() % 5);
    const now = moment(today);
    if (!schedule) {
        now.add(next, 'minutes');
    }
    const [date, setDate] = React.useState(today.format('YYYY-MM-DD'));
    const [time, setTime] = React.useState(now.format('HH:mm'));

    const handleChange = React.useCallback(
        (field, date) => {
            let _date = date;
            let newDate = schedule ? new Date(schedule) : new Date();
            if (field === 'time') {
                if (!date) {
                    _date = '00:00';
                }
                setTime(_date);
                let parseHour = _date.split(':');
                newDate.setHours(parseHour[0], parseHour[1]);
            }
            if (field === 'date') {
                setDate(_date);
                let parseDate = _date.split('-');
                newDate.setFullYear(parseDate[0]);
                newDate.setMonth(parseDate[1] - 1);
                newDate.setDate(parseDate[2]);
            }
            setSchedule(newDate);
        },
        [schedule]
    );

    const locale = i18n.language;

    return (
        <div className="date-time-container">
            <div className="date-container">
                <label className="label">
                    <Trans i18nKey="ticket.event.minisite.publishModal.publish-date" />
                </label>
                <Date.Input
                    value={date}
                    locale={locale}
                    minDate={moment()}
                    onChange={value => {
                        handleChange('date', value);
                    }}
                    returnFormat={'YYYY-MM-DD'}
                />
            </div>
            <div className="time-container">
                <label className="label">
                    <Trans i18nKey="ticket.event.minisite.publishModal.publish-hour" />
                </label>
                <Time
                    value={time}
                    step={5}
                    onChange={value => {
                        handleChange('time', value);
                    }}
                />
            </div>
        </div>
    );
}

DateTime.propTypes = {
    schedule: PropTypes.any,
    setSchedule: PropTypes.func.isRequired
};

export default function SchedulePublish({ schedule, setSchedule, disablePublish }) {
    return (
        <div className="schedule-publish">
            <div className="schedule-helptext">
                <Trans i18nKey="ticket.event.minisite.publishModal.content-schedule" />
            </div>
            <Section>
                <DateTime schedule={schedule} setSchedule={setSchedule} />
            </Section>
            {disablePublish && (
                <Message type="danger">
                    <Trans i18nKey="ticket.event.minisite.publishModal.error-message" />
                </Message>
            )}
        </div>
    );
}

SchedulePublish.propTypes = {
    schedule: PropTypes.any,
    setSchedule: PropTypes.func.isRequired,
    disablePublish: PropTypes.bool.isRequired
};
